import { render, staticRenderFns } from "./PagedReaderPaperSheet.vue?vue&type=template&id=5290789a&scoped=true&"
import script from "./PagedReaderPaperSheet.vue?vue&type=script&lang=ts&"
export * from "./PagedReaderPaperSheet.vue?vue&type=script&lang=ts&"
import style0 from "./PagedReaderPaperSheet.vue?vue&type=style&index=0&id=5290789a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5290789a",
  null
  
)

export default component.exports